import React, { useState } from 'react';
import usePaymentInputs from 'react-payment-inputs/lib/usePaymentInputs';
import PropTypes from 'prop-types';
import Modal from '../../../../_common/Modal/Modal';
import classes from './addNewCard.module.scss';
import InputField from '../../../../_common/Form/TextFields/InputField';
import Select from '../../../../_common/Form/Selects/Select/Select';
import Card from '../../../Scripts/Script/PaymentModal/Card/Card';
import Button from '../../../../_common/Form/Buttons/Button';

const claimOptions = ['Patient'];

const cardDefaultData = {
  cardCVC: '',
  cardExpiry: '',
  cardNumber: '',
};

const AddNewCardModal = ({
  isOpen, onClose, loading, saveCard,
}) => {
  const {
    meta: { touchedInputs, erroredInputs }, getCVCProps, getCardNumberProps, getExpiryDateProps,
  } = usePaymentInputs();

  const [focusedField, setFocusedField] = useState('');
  const [cardData, setCardData] = useState(cardDefaultData);
  const [claim, setClaim] = useState('');
  const { cardNumber, cardExpiry, cardCVC } = cardData;

  const changeCardData = (path, value) => {
    setCardData((prev) => ({ ...prev, [path]: value }));
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className={classes.payment_modal}
    >

      <div className={classes.top}>
        <div className={classes.inputs_wrapper}>
          <InputField
            rest={{
              ...getCardNumberProps({ onChange: (e) => changeCardData('cardNumber', e.target.value) }),
              maxLength: 23,
              placeholder: '',
              onFocus: () => setFocusedField('number'),
            }}
            value={cardNumber}
            label="Card Number"
            placeholder=""
            onChange={() => {}}
            wrapperClassName={classes.card_number}
            error={touchedInputs.cardNumber && erroredInputs.cardNumber}
            errorClassName={classes.error}
          />

          <div className={classes.expiry_cvc_wrapper}>
            <InputField
              rest={{
                ...getExpiryDateProps({ onChange: (e) => changeCardData('cardExpiry', e.target.value) }),
                placeholder: '',
                onFocus: () => setFocusedField('expiry'),
              }}
              onChange={() => {
              }}
              value={cardExpiry}
              label="Expiry Date"
              error={touchedInputs.expiryDate && erroredInputs.expiryDate}
              errorClassName={classes.error}
            />

            <InputField
              value={cardCVC}
              label="CVC"
              rest={{
                ...getCVCProps({ onChange: (e) => changeCardData('cardCVC', e.target.value) }),
                placeholder: '',
                onFocus: () => setFocusedField('cvc'),
              }}
              onChange={() => {
              }}
              error={touchedInputs.cvc && erroredInputs.cvc}
              errorClassName={classes.error}
            />
          </div>

          <Select
            label="Claim"
            options={claimOptions}
            currentOption={claim}
            onChange={(option) => setClaim(option)}
            wrapperClassName={classes.claim}
            zIndex={33}
          />
        </div>

        <Card
          number={cardNumber}
          expiry={cardExpiry.toString().replace(' / ', '')}
          cvc={cardCVC}
          name=""
          focused={focusedField}
        />
      </div>

      <div className={classes.button_wrapper}>
        <Button
          clearButton
          title="Cancel"
          className={classes.btn}
          onClick={onClose}
        />
        <Button
          addButton
          title="Add Card"
          className={classes.btn}
          onClick={() => saveCard(cardData)}
          loading={loading}
        />
      </div>

    </Modal>
  );
};

AddNewCardModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  saveCard: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

AddNewCardModal.defaultProps = {
  loading: false,
};

export default AddNewCardModal;
